import React from 'react';
import clsx from 'clsx';
import { ReactComponent as InfoIcon } from '../../assets/icons/info-icon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';
import { ReactComponent as ReturnIcon } from '../../assets/icons/return.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg';
import { KpiTableProps, KpiRow } from './types';
import styles from './KpiTableDesktop.module.scss';

function formatValue(value: number | null): string {
  if (value === null) return '—';
  return value.toString();
}

export function KpiTableDesktop({
  rows,
  editable,
  onKpiClick,
  onEdit,
  onDelete,
  onMethodologyClick,
  isDeleted
}: KpiTableProps) {
  const years = rows[0]?.years.map((y) => y.year) ?? [];

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.thNum}>№</th>
          <th className={styles.thName}>Название KPI</th>
          <th className={styles.thUnit}>Ед. изм.</th>
          {years.map((year, i) => (
            <React.Fragment key={year}>
              <th className={styles.thNum}>
                {i === years.length - 1 ? `План ${year}` : `План ${year}`}
              </th>
              {i < years.length - 1 && (
                <th className={styles.thNum}>Факт {year}</th>
              )}
            </React.Fragment>
          ))}
          <th className={styles.thNum}>Вес</th>
          <th className={styles.thMethod}>Методика расчёта</th>
          <th className={styles.thDept}>Оценивающее подразделение</th>
          {editable && <th className={styles.thActions} />}
          {isDeleted && <th className={styles.thActions} />}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <KpiTableRow
            key={row.id}
            row={row}
            index={index}
            editable={editable}
            onKpiClick={onKpiClick}
            onEdit={onEdit}
            onDelete={onDelete}
            onMethodologyClick={onMethodologyClick}
            isDeleted={isDeleted}
          />
        ))}
      </tbody>
    </table>
  );
}

interface RowProps {
  row: KpiRow;
  index: number;
  editable?: boolean;
  onKpiClick?: (row: KpiRow) => void;
  onEdit?: (row: KpiRow) => void;
  onDelete?: (row: KpiRow) => void;
  onMethodologyClick?: (row: KpiRow) => void;
  isDeleted?: boolean;
}

function KpiTableRow({
  row,
  index,
  editable,
  onKpiClick,
  onEdit,
  onDelete,
  onMethodologyClick,
  isDeleted
}: RowProps) {
  return (
    <tr className={styles.row}>
      <td className={styles.tdNum}>{index + 1}</td>
      <td className={styles.tdName}>
        <button className={styles.nameLink} onClick={() => onKpiClick?.(row)}>
          {row.name}
        </button>
      </td>
      <td className={clsx(styles.td, styles.tdUnit)}>{row.unit}</td>
      {row.years.map((y, i) => (
        <React.Fragment key={y.year}>
          <td className={styles.td}>{formatValue(y.plan)}</td>
          {i < row.years.length - 1 && (
            <td className={styles.td}>{formatValue(y.fact)}</td>
          )}
        </React.Fragment>
      ))}
      <td className={styles.td}>{row.weight}</td>
      <td className={styles.td}>
        <button
          className={styles.methodLink}
          onClick={() => onMethodologyClick?.(row)}
        >
          Методика&nbsp; <InfoIcon className={styles.infoIcon} />
        </button>
      </td>
      <td className={styles.td}>{row.department}</td>
      {editable && (
        <td className={styles.tdActions}>
          <button
            className={styles.actionBtn}
            onClick={() => onEdit?.(row)}
            aria-label="Редактировать"
          >
            <EditIcon />
          </button>
          <button
            className={styles.actionBtn}
            onClick={() => onDelete?.(row)}
            aria-label="Удалить"
          >
            <DeleteIcon />
          </button>
        </td>
      )}

      {isDeleted && (
        <td className={styles.tdActions}>
          <button
            className={styles.actionBtn}
            onClick={() => {}}
            aria-label="Вернуть"
          >
            <ReturnIcon />
          </button>
        </td>
      )}
    </tr>
  );
}
